import React, { HTMLInputTypeAttribute } from 'react'
import { FieldErrors, RegisterOptions } from 'react-hook-form'
import styled, { css } from 'styled-components'

import mailIcon from '../../img/mail.svg'

export type TicketTextInputProps = {
  className?: string
  defaultValue?: string | number | readonly string[] | undefined
  disabled?: boolean | undefined
  errors?: FieldErrors
  name: string
  placeholder?: string
  register?: (rules?: RegisterOptions) => React.Ref<HTMLInputElement>
  required?: boolean | undefined
  type?: HTMLInputTypeAttribute | undefined
  validations?: Omit<RegisterOptions, 'required'>
  value?: string | readonly string[] | number | undefined
}

const TicketTextInput: React.FC<TicketTextInputProps> = ({
  className,
  defaultValue,
  disabled = false,
  name,
  placeholder,
  register,
  required = false,
  type = 'text',
  validations = {},
}) => (
  <input
    className={className}
    defaultValue={defaultValue}
    disabled={disabled}
    name={name}
    placeholder={placeholder}
    ref={
      register
        ? register({
            required,
            ...validations,
          })
        : undefined
    }
    required={required}
    type={type}
  />
)

const StyledTicketTextInput = styled(TicketTextInput)<{ name: string; hasError: boolean }>`
  padding: 10px 14px 10px 14px;
  border-radius: 4px;
  min-height: 40px;
  ${({ hasError }) => css`
    border: 1px solid
      ${({ theme }) => (hasError ? theme.colors.brandRed.main : theme.colors.grayscale.gray20)};
  `};
  ${({ name }) =>
    name === 'email' &&
    css`
      background: url(${mailIcon}) no-repeat scroll 10px 9px;
      background-size: 20px;
      text-indent: 24px;
    `};
`

export default StyledTicketTextInput
